import * as yup from 'yup';
import { gstSchemaWithCheckbox } from './gstSchema';
import { panSchemaWithCheckbox } from './panSchema';
import { bankSchemaWithCheckbox } from './bankSchema';
import { PIN_CODE_REGEX } from '../../../../utils/constants/regex';

export const formSchema = yup.object({
  enterprise: yup
    .number()
    .required('Enterprise is required'),
  plantName: yup
    .string()
    .required('Plant name is required'),
  pinCode: yup
    .string()
    .required('Pin Code is required')
    .matches(
      PIN_CODE_REGEX,
      'Please enter a valid pin code'
    )
    .length(6, 'PinCode should be 6 characters'),
  plantCode: yup
    .string()
    .required('Plant Code is required')
    .max(15, 'Plant Code should be maximum 6 characters'),
  plantManager: yup
    .string()
    .max(
      255,
      'Plant Code should be maximum 255 characters'
    ),
  creditCapability: yup
    .boolean()
    .required('Credit capability is required'),
  priceSync: yup
    .boolean()
    .required('Price sync is required'),
  state: yup.number().required('State is required'),
  district: yup.string(),
  tehsil: yup.string(),
  village: yup.string(),
  districtServerId: yup.number(),
  tehsilServerId: yup.number(),
  villageServerId: yup.number(),
  address: yup
    .string()
    .max(255, 'address should be maximum 255 characters'),
  lat: yup
    .string()
    .required('Latitude is required')
    .max(255, 'Latitude should be maximum 255 characters'),
  long: yup
    .string()
    .required('Longitude is required')
    .max(255, 'Longitude should be maximum 255 characters'),
  region: yup.number().required('Region is required'),
  warehouseModel: yup
    .number()
    .required('Warehouse Model is required'),
  manualDistrict: yup
    .string()
    .when(
      'districtServerId',
      ([districtServerId], schema) => {
        return districtServerId == -1
          ? schema.max(20)
          : schema;
      }
    ),
  manualTehsil: yup
    .string()
    .when('tehsilServerId', ([tehsilServerId], schema) => {
      return tehsilServerId == -1 ? schema.max(20) : schema;
    }),
  manualVillage: yup
    .string()
    .when(
      'villageServerId',
      ([villageServerId], schema) => {
        return villageServerId == -1
          ? schema.max(20)
          : schema;
      }
    ),
  deliveryModel: yup
    .number()
    .required('Delivery Model is required')
    .default(2),
  commissionDiscount: yup
    .number()
    .required('Commission Discount is required')
    .typeError('Commission Discount is required')
    .test(
      'range-error',
      'Commission Discount must be between 0 and 100',
      (value) => {
        return 0 <= value && value <= 100;
      }
    )
    .default(0),
  gstSchema: gstSchemaWithCheckbox,
  panSchema: panSchemaWithCheckbox,
  bankSchema: bankSchemaWithCheckbox,
});

export type TFormData = yup.InferType<typeof formSchema>;
